/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ImportLdapUsersRequest interface.
 */
export function instanceOfImportLdapUsersRequest(value) {
    if (!('dns' in value) || value['dns'] === undefined)
        return false;
    return true;
}
export function ImportLdapUsersRequestFromJSON(json) {
    return ImportLdapUsersRequestFromJSONTyped(json, false);
}
export function ImportLdapUsersRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dns': json['dns'],
    };
}
export function ImportLdapUsersRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'dns': value['dns'],
    };
}
